var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessNetworkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1964_9552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.0795 2.61094C7.0795 1.17127 5.90823 0 4.46856 0C1.00478 0.143438 1.00576 5.079 4.46856 5.22188C5.90828 5.22188 7.0795 4.05061 7.0795 2.61094Z",
    fill: "#637381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93752 10.4937V9.6906C8.69133 3.76068 0.243984 3.76527 0 9.69055V10.4937C0 10.882 0.314812 11.1968 0.703125 11.1968H8.23439C8.6227 11.1968 8.93752 10.882 8.93752 10.4937Z",
    fill: "#637381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.142 2.61094C22.142 1.17127 20.9707 0 19.5311 0C16.0673 0.143438 16.0683 5.079 19.5311 5.22188C20.9707 5.22188 22.142 4.05061 22.142 2.61094Z",
    fill: "#637381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5312 5.22192C17.0672 5.22192 15.0625 7.22663 15.0625 9.69066V10.4938C15.0625 10.8821 15.3773 11.1969 15.7656 11.1969H23.2968C23.6852 11.1969 24 10.8821 24 10.4938V9.69066C24 7.22663 21.9953 5.22192 19.5312 5.22192Z",
    fill: "#637381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41862 12.753C4.41862 12.7029 4.41956 12.6529 4.4205 12.603H3.01425C2.95828 15.6171 4.41937 18.3402 6.68194 19.9984C6.88406 19.5693 7.13662 19.1686 7.43194 18.8037C5.60156 17.4197 4.41862 15.2246 4.41862 12.753Z",
    fill: "#CDD2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89718 5.83405C10.7673 4.95824 13.2329 4.95824 15.1031 5.83405C15.4365 5.4516 15.8186 5.1126 16.2395 4.82675C13.7507 3.42524 10.2496 3.42529 7.76074 4.82675C8.18168 5.1126 8.56371 5.45164 8.89718 5.83405Z",
    fill: "#CDD2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5798 12.603C19.6344 15.115 18.436 17.3968 16.5684 18.8037C16.8637 19.1685 17.1162 19.5693 17.3184 19.9984C19.5808 18.3403 21.0421 15.617 20.986 12.603H19.5798Z",
    fill: "#CDD2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6107 15.4142C14.6107 13.9745 13.4395 12.8032 11.9998 12.8032C8.53603 12.9467 8.53701 17.8822 11.9998 18.0251C13.4395 18.0251 14.6107 16.8539 14.6107 15.4142Z",
    fill: "#637381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18.0249C9.53591 18.0249 7.53125 20.0296 7.53125 22.4936V23.2968C7.53125 23.6851 7.84606 23.9999 8.23438 23.9999H15.7656C16.154 23.9999 16.4688 23.6851 16.4688 23.2968V22.4937C16.4687 20.0296 14.4641 18.0249 12 18.0249Z",
    fill: "#637381"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1964_9552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessNetworkIcon);
export default __webpack_public_path__ + "static/media/BusinessNetworkIcon.76d975ee1cf0f509f68cd460029bfbe6.svg";
export { ForwardRef as ReactComponent };